import Layout from "../../components/layout";
import aboutUsImage from "../../assets/images/aboutus-min.png";
const About = () => {
  return (
    <Layout>
      <section className='container mx-auto flex'>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            درباره تیارا
          </div>
          <div className='p-4 text-justify	'>
            <img
              src={aboutUsImage}
              alt='About Tiara'
            />
            <br />
            سرویس سفارش آنلاین رستوران طبقاتی تیارا یک برنامه سفارش غذای بیرون
            بر مخصوص رستوران بین المللی تیارا که سفارش اینترنتی غذا را برای مردم
            اهواز به ارمغان آورده است و متعلق به آقای محمد غریب وند نوترکی است.
            انواع غذاهای سنتی، فست فود، دسر و انواع نوشیدنی ها را فقط با چند
            کلیک سفارش دهید. سفارش شما بلا فاصله در آشپزخانه تیارا است و با
            کمترین تاخیر درب خانه شما خواهد بود
            <br />
            <br />
            از جمله ویژگیهای این سرویس می توان به موار زیر اشاره کرد:
            <br />
            <ul>
              <li>صرفه جویی در وقت و هزینه</li>
              <li>مشاهده همه منوهای به روز بهمراه جزئیات هر غذا و تصویر آن</li>
              <li>اطلاع از قیمت، موجودی و توضیحات غذاها بصورت آنلاین</li>
              <li>ثبت نام مشترکین و گرفتن کد اشتراک از طریق اپلیکیشن</li>
              <li>
                امکان انتخاب روش های مختلف خرید شامل پرداخت اینترنتی، نقدی یا
                کارتخوان در محل تحویل
              </li>
              <li>انتخاب شیوه تحویل غذا بصورت حضوری در رستوران یا ارسال پیک</li>
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
